// NGRX

// OLCI
import { OlciActionTypes } from '../actions';

export interface State {
	openedModalName: string | any;
	isLoading: boolean;
	exitUrl: string | any;
	logoutFromGA: boolean;
}

export const initialState: State = {
	openedModalName: null,
	isLoading: false,
	exitUrl: null,
	logoutFromGA: false
};

export function reducer(state: State = initialState , action: any): State {
	switch (action.type) {
		case OlciActionTypes.SHOW_LOADER:
			return Object.assign({}, state, { isLoading: true });

		case OlciActionTypes.HIDE_LOADER:
			return Object.assign({}, state, { isLoading: false });

		case OlciActionTypes.OPEN_MODAL:
			const name = action.payload.name;
			const url = action.payload.url;
			const closeGASession = !!action.payload.logoutFromGA;
			return Object.assign({}, state, { openedModalName: name, exitUrl: url, logoutFromGA: closeGASession });

		case OlciActionTypes.CLOSE_MODAL:
			return Object.assign({}, state, { openedModalName: 'close', exitUrl: null });

		default:
			return state;
	}
}

export const getOpenedModalName = (state: State) => state.openedModalName;
export const isLoading = (state: State) => state.isLoading;
export const getExitUrl = (state: State) => state.exitUrl;
export const getLogoutFromGA = (state: State) => state.logoutFromGA;
